// extracted by mini-css-extract-plugin
export default {"collapse":"styles_collapse__-Dptw","panel":"styles_panel__OmaHA"};